import ItemPayload from "@/dto/company/ItemPayload";

export default class SaveOwnershipSnapshotPayload {
    public effectiveDate: string | null = null;
    public comment: string | null = null;
    public items: Array<ItemPayload> = [];
}
